import * as React from 'react';
import { Button } from '../../../../commonv2/components/Button';
import './eyecatch.module.scss';
import { expandImageParams } from '../../../../commonv2/utils/image';
import { Coach } from '../../../types/coach';
import { routingStore } from '../../../../common/stores/routing';
import { V2Routes } from '../../../routes';
import { EventDetails } from '../../../types/event';
import { EventStatusUtils } from '../utils/EventStatusUtils';

type CoachProps = {
    coach: Coach;
};

const CoachSummary = ({ coach }: CoachProps) => {
    return (
        <div styleName="tutor-info">
            <div>
                <img src={coach.profile_photo_url} styleName="tutor-profile-image" />
            </div>
            <div styleName="tutor-tutor-title">{coach.title}</div>
            <div styleName="tutor-tutor-name">{coach.name}</div>
        </div>
    );
};

type Props = {
    event: EventDetails;
    alreadyReserved: boolean;
};

export class EyeCatch extends React.Component<Props> {
    render() {
        const { event, alreadyReserved } = this.props;
        return (
            <div styleName="container">
                <div styleName="image-wrapper">
                    <img {...expandImageParams(event.cover_photo_url)} styleName="image" />
                </div>
                <div styleName="right-column" style={{ backgroundColor: event.key_color }}>
                    <div styleName="right-column-inner">
                        <div styleName="highlight">{event.highlight}</div>
                        <div styleName="title">{event.title}</div>
                        <div styleName="subtitle">{event.sub_title}</div>

                        <div styleName="tutors">
                            {event.coaches.map((coach) => {
                                return <CoachSummary key={coach.id} coach={coach} />;
                            })}
                        </div>
                        <div styleName="reserve-button">
                            <Button
                                type="primary"
                                disabled={EventStatusUtils.shouldDisable(alreadyReserved, event)}
                                onClick={() => routingStore.push(V2Routes.eventReservationPage(event.id))}
                            >
                                {EventStatusUtils.getButtonText(alreadyReserved, event)}
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
